// mutations
const ADMIN_CARNETS_ALL = (state, adminCarnets) => {
  if (adminCarnets.code === 1) {
    state.adminCarnets = adminCarnets.data
    state.status = 'success'
  } else {
    alert(adminCarnets.message)
    state.status = 'error'
  }
}

const ADMIN_CARNETS_FORM = (state, adminCarnets) => {
  if (adminCarnets.code === 1) {
    state.adminCarnets = adminCarnets.data
    state.status = 'success'
  } else {
    alert(adminCarnets.message)
    state.status = 'error'
  }
}

const ADMIN_CARNETS_SHOW = (state, adminCarnets) => {
  if (adminCarnets.code === 1) {
    state.adminCarnets = adminCarnets.data
    state.adminCarnets.user = adminCarnets.data.formData
    state.status = 'success'
  } else {
    alert(adminCarnets.message)
    state.status = 'error'
  }
}

const ADMIN_CARNETS_CREATE = (state, adminCarnets) => {
  if (adminCarnets.code === 1) {
    state.adminCarnets = adminCarnets.data
    state.status = 'success'
    alert(adminCarnets.message)
  } else {
    alert(adminCarnets.message)
    state.status = 'error'
  }
}

const ADMIN_CARNETS_UPDATE = (state, adminCarnets) => {
  if (adminCarnets.code === 1) {
    state.adminCarnets = adminCarnets.data
    state.status = 'success'
  } else {
    alert(adminCarnets.message)
    state.status = 'error'
  }
}

const ADMIN_CARNETS_UPDATE_CODE = (state, adminCarnets) => {
  if (adminCarnets.code === 1) {
    state.adminCarnets = adminCarnets.data
    state.status = 'success'
  } else {
    alert(adminCarnets.message)
    state.status = 'error'
  }
}

const ADMIN_CARNETS_DELETE = (state, adminCarnets) => {
  if (adminCarnets.code === 1) {
    state.adminCarnets = adminCarnets.data
    state.status = 'success'
    alert(adminCarnets.message)
  } else {
    alert(adminCarnets.message)
    state.status = 'error'
  }
}

const ADMIN_VALIDATE_USER = (state, adminCarnets) => {
  if (adminCarnets.code === 1 || adminCarnets.code === 2) {
    state.adminCarnets.user = adminCarnets.data
  } else {
    alert(adminCarnets.message)
    state.status = 'success'
  }
}

export default {
  ADMIN_CARNETS_ALL,
  ADMIN_CARNETS_FORM,
  ADMIN_CARNETS_SHOW,
  ADMIN_CARNETS_CREATE,
  ADMIN_CARNETS_UPDATE,
  ADMIN_CARNETS_DELETE,
  ADMIN_VALIDATE_USER,
  ADMIN_CARNETS_UPDATE_CODE
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/carnets/mutations.js